export default __webpack_public_path__ + "static/media/mental-health-logo.85b3e986.svg";